import apiProduct from '../../../api/supplier/product';

const defaultState = () => ({
	listProduct: [],
	listProductUnit: [],
	ProductPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setProduct(state, data) {
		state.listProduct = data.data
		state.ProductPagination = data.pagination;
	},
	setProductUnit(state, data) {
		state.listProductUnit = data
	},
	saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alert = ''
	},
	resetResponse(state) {
		state.response = {
			code: '',
			message: ''
		}
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataProduct(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getDataProduct({ dispatch, commit }, params) {
		apiProduct.getDataProduct(params).then(({ data: { data } }) => {
			commit('setProduct', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setProduct', { data: [], pagination: {} });
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	getProductUnit({ dispatch, commit }, params) {
		apiProduct.getProductUnit(params).then(({ data: { data } }) => {
			commit('setProductUnit', data.results);
		}).catch((err) => {
			commit('setProductUnit', data);
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	async exportDataProduct({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiProduct.exportDataProduct(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data produk'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async addProduct({ commit, dispatch }, params) {
		commit('resetResponse')
		await apiProduct.addDataProduct(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menambahkan Produk'
			}, { root: true });
		});
	},
	async updateProduct({ commit, dispatch }, params) {
		commit('resetResponse')
		await apiProduct.editDataProduct(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah Produk'
			}, { root: true });
		});
	},
	async deleteProduct({ commit, dispatch }, params) {
		commit('resetResponse')
		await apiProduct.deleteDataProduct(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus Produk'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};